import React from "react";

type AccountMenuProps = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  className?: string;
};

export default function AccountMenu({
  children,
  style,
  onClick,
  className = "",
}: AccountMenuProps) {
  return (
    <div
      className={`flex items-center text-slate-100 hover:bg-slate-200 hover:text-black px-3 py-2 rounded-md text-sm font-medium ${className}`}
      style={style}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.currentTarget.click();
        }
      }}
    >
      {children}
    </div>
  );
}
